import React, {Component} from "react";
import Chart from "react-apexcharts";
import PropTypes from "prop-types";

const PcsLineChart = (props) => {
    const INITIAL: any = []
    const [lineChartData, setLineChartData] = React.useState(INITIAL);
    const [lineChartOptions, setLineChartOptions] = React.useState({});

    React.useEffect( () => {

        let y1 = [];
        let y2 = [];
        let x = []
        if(!!props.data) {
            y1 = props.data.y1;
            y2 = props.data.y2;
            x = props.data.x;
        }
        setLineChartData([
            {
                name: 'GSD',
                data: y1
            },
            {
                name: 'Cycle Time',
                data: y2
            }
        ])

        setLineChartOptions({
            chart: {
                width: '100%',
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                      }
                },
                zoom: {
                    enabled: false
                }

            },
            colors: ['#05d20d', '#f44336'],
            stroke: {
                width: 2,
                curve: 'smooth'
            },
            legend: {
                show: false
            },
            xaxis: {
                categories: x,
                labels: {
                    trim: true,
                    minHeight: 70,
                    maxHeight: 70,
                    style: {
                        fontSize: '12px'
                    }
                },
                title: {
                    text: 'SSV vs CT',
                }
            },
            yaxis: {
                title: {
                    text: 'Time (s)'
                }

            },
        })
    }, [props])

    return(
        <Chart options={lineChartOptions} series={lineChartData} type='line' width={props.width} height={props.height} />
    )
}
PcsLineChart.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    data: PropTypes.object.isRequired,
}

export default PcsLineChart;
